<script lang="ts">
    import {Vue, Component} from 'vue-facing-decorator'

    @Component
    export class LoadMixin extends Vue {
        async mounted() {
            await this.$store.restored
            this.load()
        }
    }

    export default LoadMixin
</script>
